/* eslint-disable no-unused-vars */
import { useUserSecurityStore } from "@/stores/usersecurity";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { useLoaderStore } from "@/stores/loader";

export const SetupInterceptors = (http) => {
  http.interceptors.request.use(async function (httpConfig) {
    const userStore = useUserSecurityStore();
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
    let token = "";
    if (key !== null) {
      let renew = false;
      const now = Date.now();
      const lastFetched = key.tokenExpiry;
      const duration = moment.duration(moment(lastFetched).diff(moment(now)));
      const getSeconds = duration.asSeconds();
      if (getSeconds > 30) {
        renew = false;
      } else {
        renew = true;
      }

      if (renew) {
        const loaderStore = useLoaderStore();
        loaderStore.startLoading();
        // console.log("Request started 1");
        await userStore
          .refresh(key.refreshToken)
          .then((authData) => {
            const loaderStore = useLoaderStore();
            loaderStore.stopLoading();
            // console.log("Request finished 1");
            token = authData.access_token;
            var d = new Date();
            d.setSeconds(d.getSeconds() + authData.expires_in);
            const timestamp = Date.parse(d);
            var obj = {
              accessToken: authData.access_token,
              refreshToken: authData.refresh_token,
              tokenExpiry: timestamp,
            };
            localStorage.setItem("FR-SDK-nvtx-admin", JSON.stringify(obj));
          })
          .catch((err) => {
            const loaderStore = useLoaderStore();
            loaderStore.stopLoading();
            // console.log("Request ended with error 1");
            if (err.response) {
              if (err.response.status === 408) {
                console.log(
                  "Authentication session is timeout. Please try again"
                ); // Please change to alert or notify box.
                console.error("", err);
              } else if (err.response.status === 401) {
                console.log("Your credential is invalid. Please try again"); // Please change to alert or notify box.
              } else {
                console.error("", err);
                console.log(
                  "Authentication Failed. Please try again." + err.response
                ); // Please change to alert or notify box.
              }
            } else {
              console.log("Unexpected Error. Please reload and try again."); // Please change to alert or notify box.
            }
            Swal.fire({
              backdrop: true,
              allowOutsideClick: false,
              title: err.message,
              text:
                "URL : " +
                JSON.stringify(err.response.config.url) +
                " , Data : " +
                JSON.stringify(err.response.config.data),
              type: "error",
              showCancelButton: 0,
              confirmButtonText: "OK",
              confirmButtonColor: "#8CD4F5",
            }).then((result) => {
              if (result.isConfirmed) {
                return window.location.assign("/");
              }
            });
          });
      } else {
        token = key.accessToken;
      }

      if (token !== "") {
        httpConfig.headers["Authorization"] = `Bearer ${token}`;
        httpConfig.headers["Content-Type"] = "application/json";
        const loaderStore = useLoaderStore();
        loaderStore.startLoading();
        // console.log("Request started 2");
        return httpConfig;
      } else {
        const loaderStore = useLoaderStore();
        loaderStore.stopLoading();
        // console.log("Request ended with error 2");
        console.log("err 2 : Invalid Token ");
        Swal.fire({
          backdrop: true,
          allowOutsideClick: false,
          title: "",
          text: "Invalid Token",
          type: "error",
          showCancelButton: 0,
          confirmButtonText: "OK",
          confirmButtonColor: "#8CD4F5",
        }).then((result) => {
          if (result.isConfirmed) {
            return window.location.assign("/");
          }
        });
      }
    } else {
      const loaderStore = useLoaderStore();
      loaderStore.stopLoading();
      // console.log("Request ended with error 3");
      console.log("no key !!! ");
      Swal.fire({
        backdrop: true,
        allowOutsideClick: false,
        title: "",
        text: "Key is null ",
        type: "error",
        showCancelButton: 0,
        confirmButtonText: "OK",
        confirmButtonColor: "#8CD4F5",
      }).then((result) => {
        if (result.isConfirmed) {
          return window.location.assign("/");
        }
      });
    }
  });

  http.interceptors.response.use(
    (response) => {
      // console.log("Request finished 3");
      const loaderStore = useLoaderStore();
      loaderStore.stopLoading();
      return response;
    },
    (error) => {
      // console.log("Request failed 4");
      const loaderStore = useLoaderStore();
      loaderStore.stopLoading();
      return Promise.reject(error);
    }
  );

  http.interceptors.response.use(null, async (error) => {
    // console.log("Request failed 5");
    const loaderStore = useLoaderStore();
    loaderStore.stopLoading();
    if (error.config && error.response && error.response.status === 401) {
      console.log("err x1 : ", JSON.stringify(error.response));
      Swal.fire({
        backdrop: true,
        allowOutsideClick: false,
        title: error.message,
        text:
          "URL : " +
          JSON.stringify(error.response.config.url) +
          " , Data : " +
          JSON.stringify(error.response.config.data),
        type: "error",
        showCancelButton: 0,
        confirmButtonText: "OK",
        confirmButtonColor: "#8CD4F5",
      }).then((result) => {
        if (result.isConfirmed) {
          return window.location.assign("/");
        }
      });
    } else if (
      error.config &&
      error.response &&
      error.response.status === 403
    ) {
      console.log("err x2 : ", JSON.stringify(error.response));
      Swal.fire({
        backdrop: true,
        allowOutsideClick: false,
        title: error.message,
        text:
          "URL : " +
          JSON.stringify(error.response.config.url) +
          " , Data : " +
          JSON.stringify(error.response.config.data),
        type: "error",
        showCancelButton: 0,
        confirmButtonText: "OK",
        confirmButtonColor: "#8CD4F5",
      }).then((result) => {
        if (result.isConfirmed) {
          return window.location.assign("/");
        }
      });
    } else {
      console.log("err x3 : ", JSON.stringify(error));
      Swal.fire({
        backdrop: true,
        allowOutsideClick: false,
        title: error.message,
        text:
          "URL : " +
          JSON.stringify(error.response.config.url) +
          " , Data : " +
          JSON.stringify(error.response.config.data),
        type: "error",
        showCancelButton: 0,
        confirmButtonText: "OK",
        confirmButtonColor: "#8CD4F5",
      }).then((result) => {
        if (result.isConfirmed) {
          return window.location.assign("/");
        }
      });
    }
  });
};

export default SetupInterceptors;
